import * as React from 'react';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const CssTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#ffffff',
      width: '100%'
    },
    '& label.Mui-focused, & label.MuiFormLabel-filled': {
      display: 'none'
    }
  }
})(TextField);

const SimpleOutlinedInput = (props: TextFieldProps) => {
  return <CssTextField {...props} variant="outlined" size="small" InputLabelProps={{ shrink: false }} />;
};

export default SimpleOutlinedInput;
